import React from 'react'
import {Link} from 'react-router-dom';
import './ShopBy.scss';
const ShopByComponent = () => {
  return (
    <div className="category">
                <div className="category__title">
                  CATEGORY <i class="fas fa-sort fa-1x"></i>
                </div>

                <div className="category__links">
                  <Link to="/category/Fruits">Fruits</Link>
                  <Link to="/category/Vegetables">Vegetables</Link>
                  <Link to="/category/Meat">Meat and Fish</Link>
                  <Link to="/category/Snacks">Snacks</Link>
                  <Link to="/category/Oil">Oil and Masala</Link>
                </div>
             

              <div className="category my-5">
                <div className="category__title">
                  SHOP BY PRICE <i class="fas fa-sort fa-1x"></i>
                </div>

                <div className="category__links">
                  <Link to="/category/Filter">$100 - $150</Link>
                  <Link to="/category/Filter">$150 - $200</Link>
                  <Link to="/category/Filter">$200 - $250</Link>
                  <Link to="/category/Filter">$250 - $300</Link>
                  <Link to="/category/Filter">$300 - $500</Link>
                </div>
              </div>
              </div>    
  )
}

export default ShopByComponent;

